exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);", ""]);

// Module
exports.push([module.id, ".CreateNewClient-module__search_bar_input__3GgIk .ant-input {\n  border: none;\n  border-radius: unset;\n  height: 40px;\n  font-size: 14px;\n}\n.CreateNewClient-module__search_bar_input__3GgIk .anticon-search.ant-input-search-icon {\n  font-size: 18px;\n}\n.CreateNewClient-module__search_bar_input__3GgIk .anticon-close-circle.ant-input-clear-icon {\n  font-size: 16px;\n}\n:root {\n  --status-color-complete: #ffffff;\n  --status-color-aborted: #d1d0ce;\n  --status-color-queued: #ffc;\n  --status-color-error: #ffd5d5;\n  --status-color-executing: #efe;\n  --status-color-default: #f5f5f5;\n}\n", ""]);

// Exports
exports.locals = {
	"search_bar_input": "CreateNewClient-module__search_bar_input__3GgIk"
};